import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SesionService } from 'src/app/core/service/sesion.service';
import {
  FileDto,
  UploadScreenInfo,
} from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { InfoCommerce, TaxValidation, TypePerson } from '../tax-validation/model/tax-validation';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';
import { CreateFile, DocKey, DocName, DocumentId } from 'src/app/core/model/constans';
import { FileUploadService } from './service/file-upload.service';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Output()
  onComplete = new EventEmitter<number>();

  @Output()
  onBack = new EventEmitter();
  files: any[] = [];
  documentForm: FormGroup;
  form: FormGroup;
  submitted: boolean;
  loading: boolean;
  cantFiles = 0;
  fileSesion: UploadScreenInfo = {
    fileDoc: [],
    ciValidationRequired: false,
  };
  isSHL: boolean = false;
  infoCommerce: InfoCommerce | undefined;
  potentialCustomer: PotentialCustomer | null;
  infoTax: TaxValidation | null;
  validateCount: number;
  filesUpload: FileDto[] = [];
  ocrError: boolean = false;
  dniValidationRequired: boolean;

  constructor(
    private readonly fb: FormBuilder,
    private readonly sesion: SesionService,
    private readonly service: FileUploadService,
    public shadowScroll: ShadowScrollService,
  ) {
    this.potentialCustomer = this.sesion.getItem('potential_customer');
    this.infoTax = this.sesion.getItem('tax_validation');
    this.service.getUploadFile().subscribe((data) => {
      this.fileSesion = data;
    });
    this.submitted = false;
    this.validateCount = 0;
    this.loading = false;
    this.dniValidationRequired = false;
    this.setFiles();
    this.documentForm = this.fb.group({});
    this.form = this.fb.group({
      option: [''],
    });
  }

  ngOnInit(): void {
    this.getFilesSesion();
    this.documentForm.valueChanges.subscribe((value) => {
      console.log('antes del hide');
      this.service.hideSpinner();
    });
  }

  setFiles() {
    this.files = [];
    if (this.infoTax?.typePerson == TypePerson.JURIDICA) {
      this.createFile(
        DocName.CI_FRENTE_PRESIDENTE,
        'file 1',
        ['.png', '.jpeg', '.jpg'],
        20,
        true,
        false,
        DocumentId.CI_FRENTE_PRESIDENTE,
        true,
        DocKey.CI_FRENTE_PRESIDENTE,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        DocName.CI_DORSO_PRESIDENTE,
        'file 2',
        ['.png', '.jpeg', '.jpg'],
        20,
        true,
        false,
        DocumentId.CI_DORSO_PRESIDENTE,
        true,
        DocKey.CI_DORSO_PRESIDENTE,
        CreateFile.ONE_FILE,
      );

      this.createFile(
        DocName.ESTATUTO,
        'file 3',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.ESTATUTO,
        true,
        DocKey.ESTATUTO,
      );

      this.createFile(
        DocName.CEDULA_APODERADO_RESIDENTE,
        'file 4',
        ['.png', '.jpeg', '.jpg'],
        20,
        true,
        false,
        DocumentId.CEDULA_APODERADO_RESIDENTE,
        false,
        DocKey.CEDULA_APODERADO_RESIDENTE,
        CreateFile.ONE_FILE,
      );
    }
    if (!this.infoTax?.ruc) {
      let id = this.files.length + 1;
      this.createFile(
        DocName.CEDULA_TRIBUTARIA,
        'file ' + id,
        ['.png', '.jpeg', '.jpg'],
        20,
        true,
        false,
        DocumentId.CEDULA_TRIBUTARIA,
        true,
        DocKey.CEDULA_TRIBUTARIA,
        CreateFile.ONE_FILE,
      );
      id++;
      this.createFile(
        DocName.ACTA,
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.ACTA,
        true,
        DocKey.ACTA,
      );
      id++;
      this.createFile(
        DocName.CEDULA_REPRESENTANTE,
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.CEDULA_REPRESENTANTE,
        true,
        DocKey.CEDULA_REPRESENTANTE,
      );
    }
    let id = this.files.length + 1;
    this.createFile(
      DocName.DOCUMENTO_PODER,
      'file ' + id,
      ['.png', '.jpeg', '.jpg', '.pdf'],
      20,
      true,
      false,
      DocumentId.DOCUMENTO_PODER,
      false,
      DocKey.DOCUMENTO_PODER,
    );
  }

  createFile(
    label: string,
    fileId: string,
    extensions: string[],
    size: number,
    isImg: boolean,
    validate: boolean,
    documentId: number,
    required: boolean,
    key: string,
    oneFile?: boolean,
  ) {
    let file = {
      label: label,
      fileId: fileId,
      file: null,
      extensions: extensions,
      size: size,
      isImg: isImg,
      ocrValidation: validate,
      documentId: documentId,
      oneFile: oneFile,
      required: required,
      key: key,
    };
    this.files.push(file);
  }

  back() {
    this.onBack.emit();
  }

  onSubmit() {
    this.setQuestionInfo();
    if (!this.loading) {
      this.submitted = true;
      if (this.documentForm.valid) {
        this.formComplete();
      }
    }
  }

  setQuestionInfo() {
    this.filesUpload = [];
    this.files.forEach((file, i) => {
      let fileDoc: FileDto = {
        files: this.documentForm.controls[file.key].value,
      };
      this.filesUpload[i] = fileDoc;
    });

    let upload: UploadScreenInfo = {
      fileDoc: this.filesUpload,
      ciValidationRequired: this.dniValidationRequired,
    };
    this.service.saveFiles(upload);
  }

  formComplete() {
    this.onComplete.emit(6);
  }

  getFilesSesion() {
    if (this.files) {
      let controls: any = {};
      this.files.forEach((element, i) => {
        if (element.required) {
          controls[element.key] = new FormControl(
            this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[i]?.files : '',
            [Validators.required],
          );
        } else {
          controls[element.key] = new FormControl(
            this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[i]?.files : '',
          );
        }
      });

      this.documentForm = new FormGroup(controls);
    }
  }

  addControlWithCreateFile(name: string, size: number, documentId: number, key: string) {
    let id = this.files.length + 1;
    this.documentForm.addControl(
      key,
      new FormControl(this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[this.files.length]?.files : '', [
        Validators.required,
      ]),
    );
    this.createFile(name, 'file ' + id, ['.png', '.jpeg', '.jpg'], size, true, false, documentId, true, key);
  }

  spliceFileAndSesionFile(cant: number) {
    this.files.splice(this.files.length - cant, cant);
  }

  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }

  setFileDni(
    label: string,
    fileId: string,
    extensions: string[],
    size: number,
    isImg: boolean,
    validate: boolean,
    documentId: number,
    required: boolean,
    key: string,
    oneFile?: boolean,
  ) {
    let file = {
      label: label,
      fileId: fileId,
      file: null,
      extensions: extensions,
      size: size,
      isImg: isImg,
      ocrValidation: validate,
      documentId: documentId,
      oneFile: oneFile,
      required: required,
      key: key,
    };
    return file;
  }
}
